import React, { useReducer, useEffect } from 'react';
import axios from 'axios';
import AuthContext from './authContext';
import authReducer from './authReducer';
import setAuthToken from '../../utils/setAuthToken';

const AuthState = props => {
    const initialState = {
        token: localStorage.getItem('token'),
        isAuthenticated: null,
        loading: true,
        user: null,
        error: null
    };

    const [state, dispatch] = useReducer(authReducer, initialState);

    useEffect(() => {
        const token = localStorage.getItem('token');
        if (token && token !== 'undefined') {
            loadUser();
        } else {
            localStorage.removeItem('token');
            dispatch({ type: 'AUTH_ERROR' });
        }
        // eslint-disable-next-line
    }, []);

    // Load User
    const loadUser = async (tokenOverride = null) => {
        // LocalStorage'dan veya override parametresinden token'ı al
        let token = tokenOverride || localStorage.getItem('token');
        
        if (token === 'undefined') {
            localStorage.removeItem('token');
            token = null;
        }

        console.log('Load User Çalıştı. Token:', token ? 'Mevcut' : 'Yok');
        
        if (token) {
            setAuthToken(token);
            console.log('Auth Token Set Edildi.');
        } else {
            console.log('Token bulunamadı, çıkılıyor.');
            dispatch({ type: 'AUTH_ERROR' });
            return;
        }

        try {
            console.log('GET /api/sellers/auth isteği gönderiliyor...');
            const res = await axios.get('/api/sellers/auth');
            console.log('GET /api/sellers/auth yanıtı:', res.data);
            dispatch({ type: 'USER_LOADED', payload: res.data });
        } catch (err) {
            console.error('Load User Error:', err.message);
            console.error('Sunucu Yanıtı:', err.response?.data?.msg || err.response?.data || 'Sunucu Hatası');
            alert("LoadUser Hatası: " + err.message + " | " + (err.response?.data?.msg || "Response yok"));
            dispatch({ type: 'AUTH_ERROR' });
        }
    };

    // Register User
    const register = async formData => {
        const config = {
            headers: {
                'Content-Type': 'application/json'
            }
        };

        try {
            const res = await axios.post('/api/sellers/register', formData, config);

            if (res.data.token) {
                localStorage.setItem('token', res.data.token);
                setAuthToken(res.data.token);
            }

            dispatch({
                type: 'REGISTER_SUCCESS',
                payload: res.data
            });

            if (res.data.token) {
                loadUser(res.data.token);
            }
        } catch (err) {
            console.error('Register Error:', err);
            dispatch({
                type: 'REGISTER_FAIL',
                payload: err.response?.data?.msg || err.message || 'Kayıt sırasında bir hata oluştu'
            });
        }
    };

    // Login User
    const login = async formData => {
        console.log('Login fonksiyonu çağrıldı:', formData);
        const config = {
            headers: {
                'Content-Type': 'application/json'
            }
        };

        try {
            console.log('Axios isteği gönderiliyor...');
            const res = await axios.post('/api/sellers/login', formData, config);
            console.log('Axios cevabı:', res.data);
            
            if (res.data.token) {
                console.log('Token alındı, kaydediliyor ve loadUser çağrılıyor.');
                localStorage.setItem('token', res.data.token);
                setAuthToken(res.data.token);
                
                dispatch({
                    type: 'LOGIN_SUCCESS',
                    payload: res.data
                });

                loadUser(res.data.token);
                return { success: true };
            } else {
                console.error('Login yanıtında token yok!');
                dispatch({
                    type: 'LOGIN_FAIL',
                    payload: 'Sunucudan geçersiz yanıt alındı'
                });
                return { success: false };
            }
        } catch (err) {
            const code = err.response?.data?.code;
            // İki adımlı doğrulama gerekiyorsa: hata alert'i gösterme, sayfaya kod adımını bildir.
            if (code === 'TOTP_REQUIRED' || code === 'TOTP_INVALID') {
                dispatch({ type: 'CLEAR_ERRORS' });
                return { totpRequired: true, invalid: code === 'TOTP_INVALID' };
            }

            dispatch({
                type: 'LOGIN_FAIL',
                payload: err.response?.data?.msg || err.message || 'Bağlantı Hatası'
            });
            return { success: false };
        }
    };

    // Google Login
    const googleLogin = async (token, totp_code) => {
        const config = {
            headers: {
                'Content-Type': 'application/json'
            }
        };

        try {
            console.log('Google login isteği gönderiliyor...');
            const res = await axios.post('/api/sellers/google', { token, totp_code }, config);

            if (res.data.token) {
                localStorage.setItem('token', res.data.token);
                setAuthToken(res.data.token);

                dispatch({
                    type: 'LOGIN_SUCCESS',
                    payload: res.data
                });

                loadUser(res.data.token);
                return { success: true };
            }
            return { success: false };
        } catch (err) {
            const code = err.response?.data?.code;
            // İki adımlı doğrulama gerekiyorsa: hata alert'i gösterme, sayfaya kod adımını bildir.
            if (code === 'TOTP_REQUIRED' || code === 'TOTP_INVALID') {
                dispatch({ type: 'CLEAR_ERRORS' });
                return { totpRequired: true, invalid: code === 'TOTP_INVALID' };
            }

            console.error('Google Login Error (Frontend):', err);
            dispatch({
                type: 'LOGIN_FAIL',
                payload: err.response?.data?.msg || err.message || 'Google Giriş Hatası'
            });
            return { success: false };
        }
    };

    // Logout
    const logout = () => dispatch({ type: 'LOGOUT' });

    // Clear Errors
    const clearErrors = () => dispatch({ type: 'CLEAR_ERRORS' });

    return (
        <AuthContext.Provider
            value={{
                token: state.token,
                isAuthenticated: state.isAuthenticated,
                loading: state.loading,
                user: state.user,
                error: state.error,
                register,
                login,
                googleLogin,
                logout,
                clearErrors,
                loadUser
            }}
        >
            {props.children}
        </AuthContext.Provider>
    );
};

export default AuthState;
